<template>
  <div></div>
</template>

<script>
import { camelCase, upperFirst } from "@/lodash"

import models from "@/models"

export default {
  created() {
    // console.log(this.$store)
    this.unsub = this.$store.subscribe((mutation) => {
      // console.log(mutation.type)
      const search = /(UPDATE|DESTROY|CREATE)_(.*)_SUCCEEDED/g

      if (mutation.type.match(search)) {
        try {
          const model = mutation.type.replace(search, "$2")
          const normalizedModel = upperFirst(camelCase(model))
          const pluralizedModel = models[normalizedModel].modelNamePlural

          this.$store.dispatch(`listAll${pluralizedModel}`)
        } catch {
          // console.log("could not dispatch update")
        }
      }
    })
  },
}
</script>
